import React, { useState } from "react";

export const DisabilityPain = ({
  setPatientMedicationInfo,
  patientMedicationInfo,
}) => {
  const [painDisability, setpainDisability] = useState({
    walkingLimited: "",
  });

  const handleOnChange = (e) => {
    const { name, value } = e.target;
    console.log(name, value);
    setPatientMedicationInfo({
      ...patientMedicationInfo,
      [name]: value,
    });
  };
  return (
    <>
      <div className="w-full mb-5">
        <div className="flex flex-col gap-6 2xl:w-[60%] xl:w-[60%] lg:w-[60%] md:w-[80%] w-full bg-white p-5 rounded shadow-sm">
          <div className="border-b py-6 border-[#d4d4d4]">
            <div>
              <h3 className="font-mainFont font-[600] text-[#333333] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[1.3vw] text-[3.5vw]  ">
                How much time can you stand in one location due to pain?
              </h3>
            </div>
            <div className="flex justify-start items-center gap-4 my-6 flex-wrap">
              <div className="flex justify-center items-center gap-2 flex-shrink-0  py-2 px-4 rounded-full border border-[#d4d4d4]">
                <input
                  name="timeYouCanStandInOneLocation"
                  onChange={handleOnChange}
                  type="radio"
                  value="10 mins"
                  id="Shoulder"
                  checked={
                    patientMedicationInfo.timeYouCanStandInOneLocation ===
                    "10 mins"
                  }
                />{" "}
                <label
                  htmlFor="Shoulder"
                  className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]"
                >
                  10 mins
                </label>
              </div>
              <div className="flex justify-center items-center gap-2 flex-shrink-0  py-2 px-4 rounded-full border border-[#d4d4d4]">
                <input
                  name="timeYouCanStandInOneLocation"
                  onChange={handleOnChange}
                  type="radio"
                  value="30 mins"
                  id="Arm"
                  checked={
                    patientMedicationInfo.timeYouCanStandInOneLocation ===
                    "30 mins"
                  }
                />{" "}
                <label htmlFor="Arm" className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                  30 mins
                </label>
              </div>
              <div className="flex justify-center items-center gap-2 flex-shrink-0 border border-[#d4d4d4]  py-2 px-4 rounded-full">
                <input
                  name="timeYouCanStandInOneLocation"
                  onChange={handleOnChange}
                  type="radio"
                  value="1 hr"
                  id="Forearm "
                  checked={
                    patientMedicationInfo.timeYouCanStandInOneLocation ===
                    "1 hr"
                  }
                />{" "}
                <label
                  htmlFor="Forearm "
                  className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]"
                >
                  1 hr{" "}
                </label>
              </div>
              <div className="flex justify-center items-center gap-2 flex-shrink-0  py-2 px-4 rounded-full border border-[#d4d4d4]">
                <input
                  name="timeYouCanStandInOneLocation"
                  onChange={handleOnChange}
                  type="radio"
                  value="More than 1 hr"
                  id="Hand "
                  checked={
                    patientMedicationInfo.timeYouCanStandInOneLocation ===
                    "More than 1 hr"
                  }
                />{" "}
                <label htmlFor="Hand " className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                  More than 1 hr{" "}
                </label>
              </div>
            </div>
          </div>

          <div className="border-b py-6 border-[#d4d4d4]">
            <div>
              <h3 className="font-mainFont font-[600] text-[#333333] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[1.3vw] text-[3.5vw]">
                How much time can you walk without pain?
              </h3>
            </div>
            <div className="flex justify-start items-center gap-4 my-6 flex-wrap">
              <div className="flex justify-center items-center gap-2 flex-shrink-0 border border-[#d4d4d4]  py-2 px-4 rounded-full">
                <input
                  name="timeYouCanWalkWithoutPain"
                  onChange={handleOnChange}
                  value="10 mins"
                  type="radio"
                  id="10min"
                  checked={
                    patientMedicationInfo.timeYouCanWalkWithoutPain ===
                    "10 mins"
                  }
                />{" "}
                <label htmlFor="10min" className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                  10 mins
                </label>
              </div>
              <div className="flex justify-center items-center border border-[#d4d4d4] gap-2 flex-shrink-0  py-2 px-4 rounded-full">
                <input
                  name="timeYouCanWalkWithoutPain"
                  onChange={handleOnChange}
                  value="30 mins"
                  type="radio"
                  id="30mins"
                  checked={
                    patientMedicationInfo.timeYouCanWalkWithoutPain ===
                    "30 mins"
                  }
                />{" "}
                <label htmlFor="30mins" className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                  30 mins
                </label>
              </div>
              <div className="flex justify-center items-center border border-[#d4d4d4] gap-2 flex-shrink-0  py-2 px-4 rounded-full">
                <input
                  name="timeYouCanWalkWithoutPain"
                  onChange={handleOnChange}
                  value="1 hr"
                  type="radio"
                  id="1hr"
                  checked={
                    patientMedicationInfo.timeYouCanWalkWithoutPain === "1 hr"
                  }
                />{" "}
                <label htmlFor="1hr" className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]">
                  1 hr{" "}
                </label>
              </div>
              <div className="flex justify-center items-center border border-[#d4d4d4] gap-2 flex-shrink-0  py-2 px-4 rounded-full">
                <input
                  name="timeYouCanWalkWithoutPain"
                  onChange={handleOnChange}
                  value="More than 1 hr"
                  type="radio"
                  id="moreThen"
                  checked={
                    patientMedicationInfo.timeYouCanWalkWithoutPain ===
                    "More than 1 hr"
                  }
                />{" "}
                <label
                  htmlFor="moreThen"
                  className="text-[#333333] 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw]"
                >
                  More than 1 hr{" "}
                </label>
              </div>
            </div>
          </div>

          <div className="w-full py-6  shadowsForMainWrappe  border-b border-[#d4d4d4]">
            <div>
              <h3 className="font-mainFont font-[600] text-[#333333] 2xl:text-[1.3vw] xl:text-[1.3vw] lg:text-[1.3vw] md:text-[1.3vw] text-[3.5vw]">
                Is your walking limited due to pain?
              </h3>
            </div>
            <div className="flex justify-start items-center gap-4 my-6">
              <button
                onClick={() => {
                  setpainDisability({
                    ...painDisability,
                    walkingLimited: "Yes",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    isWalkingLimited: "Yes",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full  transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.isWalkingLimited === "Yes"
                    ? "text-[#fff] BTNGradientBg"
                    : "bg-white text-black"
                }`}
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setpainDisability({
                    ...painDisability,
                    walkingLimited: "No",
                  });
                  setPatientMedicationInfo({
                    ...patientMedicationInfo,
                    isWalkingLimited: "No",
                  });
                }}
                className={`text-[#333333]   px-8 py-1 2xl:text-[1vw] xl:text-[1vw] lg:text-[1vw] md:text-[1vw] text-[3.5vw] font-mainFont font-[500] rounded-full transition-all duration-200 ease-linear shadowsForMainWrapper ${
                  patientMedicationInfo.isWalkingLimited === "No"
                    ? "text-[#fff] BTNGradientBg"
                    : "bg-white text-black"
                }`}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
